export const postActivityMessageToParent = () => {
  if (globalThis.window && window.self !== window.top) {
    window.parent.postMessage("expand-chat-request", "*");
  }
};
